/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_ArmInputs */

const en_us2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halfway between the tip of the shoulder and the elbow. Arm relaxed at your side, not flexed.`)
};

const pt_br2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No meio do braço, entre a ponta do ombro e o cotovelo. Braço relaxado ao lado do corpo, sem contrair.`)
};

const es_419_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mitad del brazo, entre la punta del hombro y el codo. Brazo relajado al costado, sin contraer.`)
};

const pt_pt2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meio do braço, entre a ponta do ombro e o cotovelo. Braço relaxado ao lado do corpo, sem contrair.`)
};

const fr_fr2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À mi-chemin entre la pointe de l'épaule et le coude. Bras relâché le long du corps, sans contracter.`)
};

const de_de2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In der Mitte zwischen Schulterspitze und Ellbogen. Arm entspannt seitlich am Körper, nicht angespannt.`)
};

const it_it2_body_measures_how_arm = /** @type {(inputs: Body_Measures_How_ArmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A metà tra la punta della spalla e il gomito. Braccio rilassato lungo il fianco, senza contrarre.`)
};

/**
* | output |
* | --- |
* | "Halfway between the tip of the shoulder and the elbow. Arm relaxed at your side, not flexed." |
*
* @param {Body_Measures_How_ArmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_arm = /** @type {((inputs?: Body_Measures_How_ArmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_ArmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_arm(inputs)
	if (locale === "es-419") return es_419_body_measures_how_arm(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_arm(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_arm(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_arm(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_arm(inputs)
	return en_us2_body_measures_how_arm(inputs)
});
export { body_measures_how_arm as "body-measures.how_arm" }